import type { ILocationVM } from '~/types';

import { combine } from './stringUtils';

export function formatAddress(location?: ILocationVM): string {
  if (!location) {
    return '';
  }

  const { address, country, state, city } = location;
  if (!address) {
    return combine(
      {
        joinWith: ', ',
      },
      combine(city || ''),
      combine(state || ''),
      ...(country !== 'Australia' ? [country] : []),
    );
  }

  return combine(
    {
      joinWith: ', ',
    },
    combine(address),
    ...(country !== 'Australia' ? [country] : []),
  );
}
